<template>
<div id="leftnavbar">

	<div id="logo">
		<svgicon icon="logo"></svgicon>
	</div>

	<div id="menu">

		<div class="link" @click="setView('/')" :class="{active:$route.path=='/'}">
			<svgicon icon="linearicons/home"></svgicon>
			Hjem
		</div>

		<div class="link" @click="setView('/clients')" :class="{active:isClient()}" v-ripple="'rgba(0,0,0,.06)'">
			<svgicon icon="linearicons/users"></svgicon>
			Kunder
		</div>
		
		<div class="link" v-if="false" @click="setView('/projects')" :class="{active:isProject()}" v-ripple="'rgba(0,0,0,.06)'">
			<svgicon icon="linearicons/rocket"></svgicon>
			Opgaver
		</div>

		<div class="link" v-if="show_beta_content" @click="setView('/timeline')" :class="{active:$route.path=='/timeline'}" v-ripple="'rgba(0,0,0,.06)'">
			<svgicon icon="ionicons/ios-calendar-outline"></svgicon>
			Timeline
		</div>

		<div class="link" @click="setView('/timelogs')" :class="{active:isTimelogs()}" v-ripple="'rgba(0,0,0,.06)'">
			<svgicon icon="linearicons/pie-chart"></svgicon>
			Tidsforbrug
		</div>

		<div class="link" @click="openTimelogger()" :class="{active:isTimelogger()}" v-ripple="'rgba(0,0,0,.06)'">
			<svgicon icon="ionicons/ios-clock-outline"></svgicon>
			Log tid
		</div>

		<div class="link" @click="setView('/economy')" :class="{active:isEconomy()}" v-if="economy_access" v-ripple="'rgba(0,0,0,.06)'">
			<svgicon icon="linearicons/briefcase"></svgicon>
			Økonomi
		</div>

		<div class="link" v-if="is_user('wp') && economy_access" @click="setView('/specs')" :class="{active:$route.path=='/specs'}" v-ripple="'rgba(0,0,0,.06)'">
			<svgicon icon="linearicons/list"></svgicon>
			Specs
		</div>

		<div class="link" v-if="show_beta_content" @click="setView('/users')" :class="{active:$route.path=='/users'}" v-ripple="'rgba(0,0,0,.06)'">
			<svgicon icon="linearicons/users"></svgicon>
			Users
		</div>

		<div class="link" v-if="economy_access" @click="setView('/reports')" :class="{active:$route.path=='/reports'}" v-ripple="'rgba(0,0,0,.06)'">
			<svgicon icon="linearicons/users"></svgicon>
			Rapporter
		</div>

		<div class="link" v-if="show_beta_content" @click="setView('/kitchensink')" :class="{active:$route.path=='/kitchensink'}" v-ripple="'rgba(0,0,0,.06)'">
			<svgicon icon="linearicons/magic-wand"></svgicon>
			Kitchen Sink
		</div>


	</div><!-- menu -->

	<div id="logged-in-area">

		<avatar :input="my_user" @click.native="setView('/my-settings')"></avatar>

		<div id="logoutbtn" @click="logOut()">Log ud</div>

	</div>

  </div>
</template>

<script>
import auth from './../auth.js';
import Avatar from '.././components/Avatar'
import mixins from '../mixins.js';
//import './../components/generated_svg_icons/'
import './../components/generated_svg_icons/linearicons/home'
import './../components/generated_svg_icons/linearicons/hourglass'
import './../components/generated_svg_icons/linearicons/briefcase'
import './../components/generated_svg_icons/linearicons/chart-bars'
import './../components/generated_svg_icons/linearicons/rocket'
import './../components/generated_svg_icons/linearicons/user'
import './../components/generated_svg_icons/linearicons/users'
import './../components/generated_svg_icons/linearicons/magic-wand'
import './../components/generated_svg_icons/linearicons/pie-chart'
import './../components/generated_svg_icons/linearicons/briefcase'
import './../components/generated_svg_icons/linearicons/heart'
import './../components/generated_svg_icons/linearicons/list'
import './../components/generated_svg_icons/linearicons/hand'
import './../components/generated_svg_icons/linearicons/store'
import './../components/generated_svg_icons/linearicons/calendar-full'
import './../components/generated_svg_icons/ionicons/ios-clock-outline'
import './../components/generated_svg_icons/ionicons/ios-calendar-outline'
import './../components/generated_svg_icons/logo'

export default {
	name: 'leftnavbar',
	components: { Avatar },
	mixins: [ mixins.db, mixins.generic ],
	data() {
		return {
			app: window.globalAppData,
			spinner: false,
			bigSpinner: false,
			globals: globals,
			//user: auth.getUser(),
		}
	}, // data
	computed: {


	},
  	methods: {
		setView(viewName) {
			globals.off_canvas_menu_active = false
			this.$router.push(viewName)
		},
		isProject(){
			var firstBit = this.$route.path.split('/')[1]
			return ( firstBit == 'projects' || firstBit == 'project' )
		},
		isClient(){
			var firstBit = this.$route.path.split('/')[1]
			return ( firstBit == 'clients' || firstBit == 'client' )
		},
		isEconomy(){
			var firstBit = this.$route.path.split('/')[1]
			return ( firstBit == 'economy' )
		},
		isTimelogs(){
			var firstBit = this.$route.path.split('/')[1]
			return ( firstBit == 'timelogs' )
		},
		isTimelogger(){
			return globals.timelogger.visible
		},
		incrementGlobalCount(){
			globals.count++
		},
		logOut(){
			var sure = confirm('Ønsker du at logge ud?')
			if(!sure) return
			auth.logout()
		},

		openTimelogger(){ eventBus.$emit('openTimelogger') },

	}, //methods
}
</script>



// WEBPACK FOOTER //
// Leftnavbar.vue?3ad1978d